
import React, { useState, useEffect, useRef, useContext } from 'react';
import { Chart } from 'primereact/chart';
import { Toast } from 'primereact/toast';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { ProgressSpinner } from 'primereact/progressspinner';


import Card from '../../../Base/Components/Card/Card';
import { toastShow } from '../../../Base/Services/ToastService';
import CalendarWeek from '../../../Base/Components/Form/CalendarWeek';


import { getProduccionFechaFinishing, getProduccionFechaSemanaFinishing } from '../../../API/Produccion/KPIs/KPIs';

import {
    borderRadius, borderColorCotton, colorCotton, borderColorSintetico, colorSintetico, footer,
    heightKPI, datalabelsBar, datalabelsLine, footerReproccess, getScales, getTitle, getRangeWeek
} from '../../../utils/KPIs/productionUtils';
import { ConfigContext } from '../../../Base/Context/ConfigContext/ConfigContext';
import { setTitlePage } from '../../../Base/Services/Config/ConfigService';


const FinishingProduction = () => {

    const { config } = useContext(ConfigContext);

    const scales = getScales(config);
    const colorTitle = getTitle(config);


    const toast = useRef(null);
    const [dates, setDates] = useState(new Date());
    const [loading, setLoading] = useState(false);
    const [finishingWeek, setFinishingWeek] = useState(null);
    const [finishingDay, setFinishingDay] = useState(null);
    const [FinishingDataWeek, setFinishingDataWeek] = useState({
        OptionsWeek: {
            interaction: {
                intersect: false,
                mode: 'index',
            },
            plugins: {
                title: {
                    display: true,
                    text: 'Finishing (Kg)',
                    color: colorTitle,
                },
                datalabels: datalabelsBar,
                tooltip: {
                    callbacks: {
                        footer: footer,
                    }
                },
            },
            scales: scales
        },
        OptionsDay: {
            interaction: {
                intersect: false,
                mode: 'index',
            },
            plugins: {
                title: {
                    display: true,
                    text: 'Finishing (Kg)',
                    color: colorTitle,
                },
                tooltip: {
                    callbacks: {
                        footer: footer,
                    }
                },
                datalabels: datalabelsLine,
                aspectRatio: 5 / 3,
                layout: {
                    padding: {
                        top: 32,
                        right: 16,
                        bottom: 16,
                        left: 8
                    }
                },
                elements: {
                    line: {
                        fill: false,
                        tension: 0.4
                    }
                },
            },
            scales: scales
        },
        data: null
    });
    const [finishingDataDay, setFinishingDataDay] = useState({
        OptionsDay: {
            interaction: {
                intersect: false,
                mode: 'index',
            },
            plugins: {
                title: {
                    display: true,
                    text: 'Finishing (Kg)',
                    color: colorTitle,
                },
                tooltip: {
                    callbacks: {
                        footer: footer,
                    }
                },
                datalabels: datalabelsLine,
                aspectRatio: 5 / 3,
                layout: {
                    padding: {
                        top: 32,
                        right: 16,
                        bottom: 16,
                        left: 8
                    }
                },
                elements: {
                    line: {
                        fill: false,
                        tension: 0.4
                    }
                },
            },
            scales: scales
        },
        data: null
    });


    const getInfo = async () => {

        if (dates) {
            setLoading(true);
            const rangeWeeks = getRangeWeek(dates)

            const tempo = await getProduccionFechaSemanaFinishing(rangeWeeks);
            const tempo2 = await getProduccionFechaFinishing(rangeWeeks);
            // console.log(tempo, tempo2)
            const aux = {
                days: [],
                KgsAC: [],
                KgsAS: [],
                KgsTotal: []
            }
            const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
            days.forEach((day, index) => {
                const tempo = tempo2.find((item) => item.NombreDia === day);
                if (tempo) {
                    aux.days.push(day);
                    aux.KgsAC.push(tempo.KgsAC);
                    aux.KgsAS.push(tempo.KgsAS);
                    aux.KgsTotal.push(tempo.KgsTotal);
                } else {
                    aux.days.push(day);
                    aux.KgsAC.push(0);
                    aux.KgsAS.push(0);
                    aux.KgsTotal.push(0);
                }
            });
            setFinishingWeek(tempo[0]);
            setFinishingDay(aux);
        } else {
            toastShow(toast, 'warn', 'Seleccione una fecha.')
        }
        setLoading(false)
    }


    useEffect(() => {
        window.document.title = 'PPF • Finishing Production'
        getInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {

        if (finishingWeek) {
            setFinishingDataWeek({
                ...FinishingDataWeek,
                dataWeek: {
                    labels: [`Semana ${finishingWeek.Semana}`],
                    datasets: [{
                        type: 'bar',
                        label: 'Cotton',
                        backgroundColor: colorCotton,
                        borderColor: borderColorCotton,
                        borderWidth: 2,
                        data: [finishingWeek.KgsAC],
                        stack: 'Stack 0',
                        borderRadius: borderRadius
                    },
                    {
                        type: 'bar',
                        label: 'Poly',
                        backgroundColor: colorSintetico,
                        borderColor: borderColorSintetico,
                        borderWidth: 2,
                        data: [finishingWeek.KgsAS],
                        stack: 'Stack 1',
                        borderRadius: borderRadius
                    },
                    ]
                }
            })
        }else{
            setFinishingDataWeek({
                ...FinishingDataWeek,
                dataWeek: null
            })
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finishingWeek])

    useEffect(() => {
        if (finishingDay) {
            setFinishingDataDay({
                ...finishingDataDay,
                dataDay: {
                    labels: finishingDay.days,
                    datasets: [{
                        type: 'line',
                        label: 'Cotton',
                        backgroundColor: colorCotton,
                        borderColor: borderColorCotton,
                        borderWidth: 2,
                        data: finishingDay.KgsAC,
                        borderRadius: borderRadius,
                        stack: 'Stack 0',
                    },
                    {
                        type: 'line',
                        label: 'Poly',
                        backgroundColor: colorSintetico,
                        borderColor: borderColorSintetico,
                        borderWidth: 2,
                        data: finishingDay.KgsAS,
                        borderRadius: borderRadius,
                        stack: 'Stack 1',
                    },
                    ]
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finishingDay])


    return (
        <div className='p-3'>
            <Toast position="bottom-right" ref={toast} />
            <Card titulo={<h4>Finishing production</h4>} contenido={
                (<div className='p-3 transitionAll-1 kpiProducction'>
                    <div>

                        <CalendarWeek
                            date={dates}
                            setDate={setDates}
                            loading={loading}
                            buscar={getInfo}
                        />
                    </div>
                    {loading ?
                        <div hidden={loading} style={{ height: '100%', zIndex: 1000, width: '100%', background: 'rgba(204, 204, 204, 0.5)', position: loading ? 'absolute' : 'none', paddingTop: '40vh' }} className='d-flex justify-content-center transitionAll-1'>
                            <ProgressSpinner />
                        </div>
                        : ''

                    }
                    <Card className={'bg-' + config.theme.toLowerCase()} contenido={(
                        <div>
                            <h4 className='m-auto text-center'>Finishing </h4>
                            <div className='row'>
                                <div className="col-6">
                                    <Chart height={heightKPI} type="bar" data={FinishingDataWeek.dataWeek} options={FinishingDataWeek.OptionsWeek} plugins={[ChartDataLabels]} />
                                </div>
                                <div className="col-6">
                                    <Chart height={heightKPI} type='line' data={finishingDataDay.dataDay} options={finishingDataDay.OptionsDay} plugins={[ChartDataLabels]} />
                                </div>
                            </div>
                        </div>
                    )} />

                </div>
                )
            }
            />
        </div>
    )
}

export default FinishingProduction